var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { size: "lg", centered: "", "hide-footer": "" },
          on: { shown: _vm.onModalShown },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center",
                style: { gap: "8px" }
              },
              [
                _c(
                  "el-tag",
                  { staticClass: "rounded-circle", attrs: { type: "warning" } },
                  [_c("i", { staticClass: "el-icon-office-building" })]
                ),
                _vm._v(
                  "\n                Editar centro de distribuição\n            "
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "cdEditForm",
              attrs: {
                model: _vm.payload,
                "label-position": "top",
                "status-icon": ""
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "codigo",
                            rules: [
                              {
                                required: true,
                                message: "O código da filial é obrigatório"
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Código da filial")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            attrs: {
                              placeholder: "Ex: 2",
                              max: 10000,
                              controls: false,
                              disabled: _vm.isLoading
                            },
                            model: {
                              value: _vm.payload.codigo,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "codigo", $$v)
                              },
                              expression: "payload.codigo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "descricao",
                            rules: [
                              {
                                required: true,
                                message: "A descrição é obrigatória"
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Descrição")]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: "Ex: Matriz",
                              disabled: _vm.isLoading
                            },
                            model: {
                              value: _vm.payload.descricao,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "descricao", $$v)
                              },
                              expression: "payload.descricao"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "_estado",
                            rules: [
                              {
                                required: true,
                                message: "O Estado é obrigatório",
                                trigger: ["blur", "change"]
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Estado")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Selecione um estado",
                                clearable: "",
                                filterable: "",
                                disabled: _vm.isLoading
                              },
                              model: {
                                value: _vm.payload._estado,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "_estado", $$v)
                                },
                                expression: "payload._estado"
                              }
                            },
                            _vm._l(_vm.ufs, function(uf) {
                              return _c("el-option", {
                                key: uf.value,
                                attrs: { label: uf.uf, value: uf.uf }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "cidade_id",
                            rules: [
                              {
                                required: true,
                                message: "A Cidade é obrigatória",
                                trigger: ["blur", "change"]
                              }
                            ]
                          }
                        },
                        [
                          _c("label", [_vm._v("Cidade")]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Selecione uma cidade",
                                clearable: "",
                                filterable: "",
                                disabled: _vm.isLoading || !_vm.payload._estado
                              },
                              model: {
                                value: _vm.payload.cidade_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "cidade_id", $$v)
                                },
                                expression: "payload.cidade_id"
                              }
                            },
                            _vm._l(_vm.cities, function(city) {
                              return _c("el-option", {
                                key: city.id,
                                attrs: { label: city.nome, value: city.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3",
                        style: { gap: "12px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            style: { gap: "8px" }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                style: { pointerEvents: "none" },
                                attrs: {
                                  type: _vm.payload.ativo
                                    ? "success"
                                    : "danger",
                                  plain: "",
                                  circle: ""
                                }
                              },
                              [
                                _vm.payload.ativo
                                  ? _c("i", { staticClass: "el-icon-unlock" })
                                  : _c("i", { staticClass: "el-icon-lock" })
                              ]
                            ),
                            _vm._v(" "),
                            _c("h6", { staticClass: "mb-0 font-weight-bold" }, [
                              _vm._v(
                                "Centro de Distribuição " +
                                  _vm._s(
                                    _vm.payload.ativo ? "Ativo" : "Inativo"
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "mb-0", attrs: { prop: "status" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "Ativo",
                                "inactive-text": "Inativo",
                                disabled: _vm.isLoading
                              },
                              model: {
                                value: _vm.payload.ativo,
                                callback: function($$v) {
                                  _vm.$set(_vm.payload, "ativo", $$v)
                                },
                                expression: "payload.ativo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-end"
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { plain: "", disabled: _vm.isLoading },
                                on: {
                                  click: function() {
                                    _vm.toggleModal()
                                    _vm.resetForm()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Cancelar\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  plain: "",
                                  disabled: _vm.isLoading
                                },
                                on: { click: _vm.onSubmit }
                              },
                              [
                                _vm.isLoading
                                  ? _c("i", { staticClass: "el-icon-loading" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("i", { staticClass: "fas fa-check-circle" }),
                                _vm._v(
                                  "\n                                Salvar\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a0bc58f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0bc58f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/cd/CdEditModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6a0bc58f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/cd/CdEditModal.vue
// module chunks = 2